// extracted by mini-css-extract-plugin
module.exports = {"pagination":"search-pagination_pagination__nNT44","bulletPage":"search-pagination_bulletPage__SU8Qz","active":"search-pagination_active__Albmj"};